import React, { useEffect, Fragment } from 'react'
import { useFormContext } from "react-hook-form"
import { Autocomplete, TextField, Typography, FormHelperText, createTheme, Popper } from '@mui/material';
import PropTypes, { InferProps } from "prop-types";
import FormErrors from '../formErrors';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';

export default function AutoCompleteSelect({
  name,
  options,
  label,
  size,
  fullWidth,
  disableClearable,
  required,
  disabled,
  onChange,
  hidden,
  subLabel,
  small,
  IsRadius,
  externalErrorMessage,
}: InferProps<typeof AutoCompleteSelect.propTypes>) {
  const {
    register,
    setValue,
    watch,
    formState: { touchedFields, isSubmitted, errors },
  } = useFormContext();

  const errorMessage = FormErrors.errorMessage(
    name,
    errors,
    touchedFields,
    isSubmitted,
    externalErrorMessage,
  );

  const PopperCustom = React.useCallback((props) => {
    return <Popper
      {...props}
      placement='bottom'
      disablePortal={true}
      modifiers={[
        {
          name: 'flip',
          enabled: false,
          options: {
            altBoundary: true,
            rootBoundary: 'document',
            padding: 8,
          },
        },
      ]}
    />;
  }, []);

  return (
    <>
      <Autocomplete
        hidden={hidden || false}
        renderOption={(props, option: any) => {
          return (
            <li {...props} key={option.value} style={option.sColor ? { backgroundColor: option.sColor } : {}}>
              {option.label}
            </li>
          );
        }}
        disabled={disabled || null}
        value={watch(name) || null}
        PopperComponent={PopperCustom}
        fullWidth={fullWidth || null}
        // componentsProps={{
        //     sx: {
        //       borderRadius: "50rem"
        //     }
        // }}
        noOptionsText={currentLanguage() == "th" ? "ไม่พบข้อมูล" : "No option"}
        disableClearable={disableClearable || null}
        size={size === "medium" ? "medium" : "small"}
        name={name}
        {...register(name)}
        onChange={(e, v) => {
          setValue(name, v, { shouldValidate: true })
          onChange && onChange(v)
        }}
        options={options || []}
        getOptionLabel={(itemOption: any) => {
          return `${itemOption.label}`
        }}
        isOptionEqualToValue={(option, value) =>
          option.value === value.value
        }
        renderInput={(params) =>
          <TextField
            error={Boolean(errorMessage)}
            required={required || null}
            disabled={disabled || null}
            // variant={ disabled ? "standard" : "outlined"}
            label={label}
            {...params}
            autoComplete="off"
            size={size === "medium" ? "medium" : "small"}
            inputRef={register(name).ref}
            fullWidth={fullWidth}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: IsRadius ? "50px" : "4px",
               
              },
              "label.MuiInputLabel-shrink": {
                backgroundColor: "rgba(255,255,255,0.95)",
                top: "0px",
              },
              ".MuiInputLabel-outlined": { 
                top: "0px",
              },
              ".MuiInputLabel-asterisk": {
                color: "red"
              },
              ".Mui-disabled": {
                backgroundColor: "#f1f1f1",
                color: "#000000"

              },
              ".MuiAutocomplete-popper": {
                transform : "none !important"
              }
             
            }}
          />}
      />
      {errors && errors[name] ? (
        <FormHelperText sx={{ color: "red" }}>
          {errors[name].message}
        </FormHelperText>
      ) : null}
      {/* {errors && errors[name] && <span className='text-[12px] text-[red] mx-[14px]'>{errors[name].message}</span>} */}
    </>
  )
}
AutoCompleteSelect.propTypes = {
  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  label: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium"]),
  fullWidth: PropTypes.bool,
  disableClearable: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  small: PropTypes.bool,
  IsRadius: PropTypes.bool,
  subLabel: PropTypes.string,
  externalErrorMessage: PropTypes.string,
};

AutoCompleteSelect.defaultProps = {
  required: false,
  options: [],
  label: "",
  fullWidth: true,
  size: "small",
  subLabel: "",
  small: true,
  IsRadius: false,
};
